import { WidgetType } from "../../../../api/types/dashboardsTypes";

export const canMaximizeWidget = (widgetType: string): boolean => {
  return widgetType === WidgetType.SmartView;
};

export const canEditWidget = (widgetType: string): boolean => {
  return widgetType === WidgetType.SmartView;
};
